<template>
  <div class="home-container container-fluid py-lg-3 py-md-3 py-sm-0 overflow-hidden">
    <div v-if="mode === 'full' " class="row justify-content-start">
      <div class="col flex-grow-1">
        <img v-if="!embed" class="ais-logo" :src="require('/src/assets/img/ais-logo.png')" alt="">
<!--        <img v-else class="ais-logo" style="height: 35px!important; width: 96px!important;"-->
<!--             :src="require('/src/assets/img/ais-logo-embed.png')" alt="">-->
      </div>
      <!--      <div class="col flex-grow-0" >-->
      <!--        <img class="ais-banner" style="width: 44px;" :src="require('/src/assets/img/banner.png')" alt="">-->
      <!--      </div>-->
    </div>
    <div class="row justify-content-center">
      <div class="mt-3 col-lg-12 col-xl-7"
           :class="{'col-12': !isMobile, 'col-12': screenMode === 'landscape' && isMobile}">
        <vimmi-player ref="player" v-if="activeChannel" class="main-player "
                      :class="{'fullscreen-player' : mode === 'player'}"
                      :active-channel="activeChannel" @on-loaded="redesign"></vimmi-player>
        <div v-if="embed && activeChannel && mode === 'full'" class="channel-item-title mt-1 mb-1 test-test" style="font-size: 20px">
          {{  translated }}
        </div>
      </div>


      <!--      <slider :channels="channels"/>-->
      <!--      <div v-if="embed" class="container text-center my-2" style="margin: 0; padding: 0">
              <div class="row mx-auto my-auto justify-content-center">
                <div id="recipeCarousel" class="carousel slide" data-bs-touch="true" data-bs-interval="false">
                  <div class="carousel-inner" role="listbox">

                    <div v-for="channel in channels" class="carousel-item  mr-2"   :class="{'active':channel === activeChannel}"
                         @click="selectChannel(channel)">
                      <div class="col-md-3 ">
                        <div class="card" style="border: none; margin-right: 1rem; max-height: 115px">
                          <div class="card-img rounded">
                            <img :title="t(channel, 'title')" :src="channel.backdrop" class="img-fluid" style="border-radius: 10px; max-height: 115px" >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a class="carousel-control-prev" href="#recipeCarousel" role="button" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon"  style="background-color: #343434;" aria-hidden="true"></span>
                  </a>
                  <a class="carousel-control-next  w-aut" style="background-color: #343434; width: 2rem; margin-right: 2rem; border-top-right-radius: 10px; border-bottom-right-radius: 10px" href="#recipeCarousel" role="button"
                     data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  </a>
                </div>
              </div>
            </div>-->
      <div v-if="!embed" class="col-12 col-lg-4 epg-wrap mt-3 mt-sm-1">
        <epg-list v-if="activeChannel" :show-only-active="onlyActiveEpg" :max-height="epgHeight"
                  :active-channel="activeChannel"></epg-list>
      </div>
    </div>
    <div v-if="mode === 'full'" class="row">
      <div class="col-12 col-md-12 col-xl-11  pt-lg-3 pt-md-1 pt-sm-1 m-auto">

        <div v-if="!embed" class="channels-title ">

          {{ tText('channels') }}
        </div>
        <div class="channels-list pb-1 w-100">

          <carousel v-if="embed" :items-to-show="4" :items-to-scroll="4" :breakpoints="breakpoints" :mouse-drag="false" class="channels-list mx-lg-2 mx-md-2 mx-sm-0"
                    style="overflow-x: hidden">
            <slide slideWidth="200" v-for="channel in channels" :key="channel.id">
              <a class="channel-item  channel-item--embed text-start text-decoration-none" :class="{'active':channel === activeChannel}"
                 target="_top"
                 :href="channel.itype === 'page_link' ? channel.link : 'javascript:;'"
                 @click="selectChannel(channel)">
                <div class="position-relative poster-wrap">
                  <div class="aspect-ratio-box">
                    <div class="aspect-ratio-box-inside">
                      <img class="channel-poster" :title="t(channel, 'title')" :src="channel.backdrop" alt="">
                    </div>
                  </div>
                  <!--              <vimmi-player :aspect-ratio="true" :active-channel="channel"></vimmi-player>-->
                  <!--              <span class="channel-item-title">{{ channel.title }}</span>-->
                </div>
                <div v-if="!embed" class="channel-item-title" :title="t(channel, 'title')">{{
                    t(channel, 'title')
                  }}
                </div>
                <!--            <span class="channel-item-epg pt-2">{{ channel.epg.length ? getActiveEpg(channel.epg)?.title : '' }}</span>-->
              </a>
            </slide>
            <!--            <slide :key="'ex_Tv'">-->
            <!--              <div  class="channel-item exclusive active text-start">-->
            <!--                <a target="_top" :href="exclusiveBanner.link">-->
            <!--                  <div class="position-relative poster-wrap">-->
            <!--                    <div class="aspect-ratio-box ar-1">-->
            <!--                      <div class="aspect-ratio-box-inside">-->
            <!--                        <img class="channel-poster" :src="exclusiveBanner.backdrop" alt="">-->
            <!--                      </div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                  <div class="channel-item-title">{{ tText('exclusive_for_ais') }}</div>-->
            <!--                </a>-->
            <!--              </div>-->
            <!--            </slide>-->

            <template #addons>
              <navigation class="mx-3" style="background-color: #343434 !important;"/>
              <!--              <pagination />-->
            </template>
          </carousel>

          <div v-if="!embed" class="channel-item  text-start" :class="{'active':channel === activeChannel}"
               v-for="(channel, cId) in channels" @click="selectChannel(channel)">
            <div class="position-relative poster-wrap">
              <div class="aspect-ratio-box ar-1">
                <div class="aspect-ratio-box-inside">
                  <img class="channel-poster" :title="t(channel, 'title')" :src="channel.poster" alt="">
                </div>
              </div>
              <!--              <vimmi-player :aspect-ratio="true" :active-channel="channel"></vimmi-player>-->
              <!--              <span class="channel-item-title">{{ channel.title }}</span>-->
            </div>
            <div v-if="!embed" class="channel-item-title" :title="t(channel, 'title')">{{ t(channel, 'title') }}</div>
            <!--            <span class="channel-item-epg pt-2">{{ channel.epg.length ? getActiveEpg(channel.epg)?.title : '' }}</span>-->
          </div>
          <div v-if="!embed" class="spacer"></div>

          <div v-if="!embed" class="channel-item exclusive active text-start">
            <a target="_top" :href="exclusiveBanner.link">
              <div class="position-relative poster-wrap">
                <div class="aspect-ratio-box ar-1">
                  <div class="aspect-ratio-box-inside">
                    <img class="channel-poster" :src="exclusiveBanner.backdrop" alt="">
                  </div>
                </div>
              </div>
              <div class="channel-item-title">{{ tText('exclusive_for_ais') }}</div>
            </a>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import 'vue3-carousel/dist/carousel.css';
  import VimmiPlayer from "../components/vimmi-player/vimmi-player";
  import EpgList from "../components/epg-list/epg-list";
  import Config from "../service/config";
  import {normDomain} from "vimmi-web-utils/cjs/normDomain";
  import epgSrv from "../service/epg";
  import {screenMode} from "vimmi-web-utils/cjs/screenMode";
  import {device} from "vimmi-web-utils/cjs/device";
  import {contentTranslate} from "../mixin/translate.js";
  import channelsSrv from "../service/channels.js";
  import {Carousel, Slide, Pagination, Navigation} from 'vue3-carousel';


  export default {
    name: 'Home',
    components: {
      EpgList,
      VimmiPlayer,
      Carousel,
      Slide,
      Pagination: Pagination,
      Navigation,
    },
    mixins: [contentTranslate],
    data() {
      return {
        // isLoading: true,
        mode: null,
        onlyActiveEpg: false,
        screenMode: screenMode(),
        isMobile: device.isAnyMobile(),
        epgHeight: 300,
        activeChannel: null,
        exclusiveBanner: {
          "title": null,
          "id": "some_id",
          "link": "",
          "itype": "page_link",
          "poster": "https://ais-s.demo-vidnt.com/ais/play/origin/VOD/Poster/exclusive.backdrop.original.jpg",
          "thumbnail": "https://ais-s.demo-vidnt.com/ais/play/origin/VOD/Poster/exclusive.backdrop.original.jpg",
          "backdrop": "https://ais-s.demo-vidnt.com/ais/play/origin/VOD/Poster/exclusive.backdrop.original.new.jpg",
          // backdrop: 'https://ais-s.demo-vidnt.com/ais/play/origin/VOD/Poster/exclusive.backdrop.original.jpg',
          // link: 'https://aisplay.ais.co.th/portal/get_section/611f146e677d560953a09387/',
        },
        channels: {},
        env: '',
        embed: false,
        model: null,
        breakpoints: {
          // 700px and up
          340: {
            itemsToShow: 2.5,
            itemsToScroll: 1.5,
            snapAlign: 'center',
          },
          700: {
            itemsToShow: 4,
            itemsToScroll: 4,
            snapAlign: 'center',
          },
          // 1024 and up
          1024: {
            itemsToShow: 6,
            itemsToScroll: 6,
            snapAlign: 'start',
          },
        },
      }
    },
    mounted() {
      this.env = process.env.VUE_APP_CUSTOMER
      if (this.env === "ais-football") {
        this.embed = true;
      }

      this.init();
      window.addEventListener('orientationchange', () => {
        setTimeout(() => {
          this.screenMode = screenMode();
          this.isMobile = device.isAnyMobile();
        }, 200)
      })

    },
    computed: {
      translated () {
        return this.t(this.activeChannel, 'title')
      }
/*      innerWidth() {
        let width = document.body.offsetWidth
        let parsed = parseInt(width)
        return parsed
        }*/
    },
    methods: {
      /* getList() {
         setTimeout(() => {
           let items = document.querySelectorAll('.carousel .carousel-item')
           items[0].classList.add('active')

           items.forEach((el) => {
             const minPerSlide = 4
             let next = el.nextElementSibling
             for (let i = 1; i < minPerSlide; i++) {
               if (!next) {
                 // wrap carousel by using first child
                 next = items[0]
               }
               let cloneChild = next.cloneNode(true)
               el.appendChild(cloneChild.children[0])
               next = next.nextElementSibling
             }
           })
         }, 1000)
       },*/
      redirectTo(link) {
        window.open(link, '_blank');
      },
      async init() {

        this.mode = this.$route.query.t === 'player' ? 'player' : 'full';
        this.language = this.$route.query.l ? ['eng', 'tha'].indexOf(this.$route.query.l) !== -1 ? this.$route.query.l : 'tha' : 'tha';

        Config.set('env', location.href.indexOf('localhost') !== -1 ? 'stg' : (location.href.indexOf('ais-stg-olympic') !== -1 || location.href.indexOf('ais-stg-embed-application') !== -1 )  ? 'stg' : 'prod');
        Config.set('backend', this.$route.query.backend ? normDomain(this.$route.query.backend) : Config.get('env') === 'stg' ? 'ais-stg-app.demo-vidnt.com' : 'aisplay.ais.co.th');
        Config.set('mode', this.mode);
        Config.set('language', this.language);
        Config.set('target_site', this.$route.query.target_site ? decodeURIComponent(this.$route.query.target_site) : null);


        window.addEventListener('resize', this.debounce(() => {
          this.redesign()
        }, 101));
        window.addEventListener('load', this.debounce(() => {

          this.redesign()

          // this.$nextTick(() => {
          //   this.isLoading = false;
          // })
        }, 100));
        if (this.embed) {
          let channels = await channelsSrv.getScreenChannels();
          this.exclusiveBanner.title = this.tText('exclusive_for_ais');
          channels[this.exclusiveBanner.id] = this.exclusiveBanner;
          this.channels = channels;
        } else {
          this.channels = await channelsSrv.getChannels();
        }
        /*      this.section = await channelsSrv.getSection();*/

        /*      for (const channel in this.channels) {
                const target_copy = Object.assign({}, channel);
              }*/

        /*      if (this.embed) {
                this.getList()
              }*/

        //
        // this.channels = await doFetch(`/${Config.get('env')}-channels.json`);

        if (!this.embed) {
          await this.loadEpg();
        }

        if (this.$route.query.ch && this.channels[this.$route.query.ch]) {
          this.activeChannel = this.channels[this.$route.query.ch];
        }else {
          this.activeChannel =  Object.values(this.channels)[0]
        }

        if(Config.get('env') === 'stg'){
          this.exclusiveBanner.link = "https://ais-stg-app.demo-vidnt.com/portal/screen/aisballthai/"
        }else if(Config.get('env') === 'prod'){
          this.exclusiveBanner.link = " https://aisplay.ais.co.th/portal/screen/aisplayballthai/"
        }
      },
      redesign() {
        if (this.activeChannel) {
          if (this.$refs.player.getPlayerHeight()) {
            this.epgHeight = this.$refs.player.getPlayerHeight();
          }
        }
        this.onlyActiveEpg = window.innerWidth < 900
      },
      selectChannel(channel) {
        if (channel.itype === 'page_link') {
          return;
        }
        this.activeChannel = channel;
        this.$nextTick(() => {
          setTimeout(() => {
            this.redesign()
          }, 100);
        })
      },
      async loadEpg() {
        let epgList = await epgSrv.getByChannels(Object.keys(this.channels));
        epgList.map((item) => {
          if (item.parent && this.channels[item.parent] && this.channels[item.parent].epgList) {
            this.channels[item.parent].epgList.push(item);
          }
        });
        return true;
      },
      debounce(fn, delay) {
        let timeoutID = null;
        let that = this
        return function () {
          clearTimeout(timeoutID)
          let args = arguments
          // let that = this
          timeoutID = setTimeout(() => {
            fn.apply(that, args)
            // fn(...args)
          }, delay);
        }
      }
    }

  }
</script>
<style lang="scss">
  .fullscreen-player{
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0 !important;
  }
  .channel-item--embed{
    width: 100% !important;
    margin: 0px 5px 0px 5px!important;
    max-height: 220px!important;
    img {
      object-fit: fill !important;
    }
    &:first-child {
      margin-right: 0px;
    }

    &:last-child {
      margin-left: 0px;
    }
  }
  .active{
    border: 3px solid #B2D234;
    border-radius: 10px;
  }
  .carousel__prev{
    opacity: 0.6;
    border-radius: 5px 0px 0px 5px;
    height: 100%;
    background-color: #343434;
  }
  .carousel__next{
    opacity: 0.6;
    border-radius: 0px 5px 5px 0px;
    height: 100%;
    background-color: #343434;
  }
  @media (max-width: 480px){
    .test-test{
      display: inline-block;
      width: 330px;
      white-space: nowrap;
      overflow: hidden !important;
      text-overflow: ellipsis;
    }
    .carousel__prev{
      display: none!important;
    }
    .carousel__next{
      display: none!important;
    }
  }
  .carousel__item {
    height: 100%;
    width: 200px;

    border-radius: 5px;
  }


  @media (max-width: 600px) {
    .carousel-inner .carousel-item > div {
      display: none;
    }
    .carousel-inner .carousel-item > div:first-child {
      display: block;
    }

  }

  .carousel-inner .carousel-item.active,
  .carousel-inner .carousel-item-next,
  .carousel-inner .carousel-item-prev {
    display: flex;
  }

  /* medium and up screens */
  @media (min-width: 600px) {

    .carousel-inner .carousel-item-end.active,
    .carousel-inner .carousel-item-next {
      transform: translateX(25%);
    }

    .carousel-inner .carousel-item-start.active,
    .carousel-inner .carousel-item-prev {
      transform: translateX(-25%);
    }
  }

  .carousel-inner .carousel-item-end,
  .carousel-inner .carousel-item-start {
    transform: translateX(0);
  }


  .home-container {
    overflow-y: auto;
    max-height: 100%;

    .ais-logo {
      width: 165px;
    }


    .channels-list {
      white-space: nowrap;
      overflow-x: auto;

      .spacer {
        display: inline-block;
        margin: 35px 15px;
        background-color: #DDE4EF;
        height: 40px;
        width: 2px;
      }

      .channel-item {
        width: 90px;
        position: relative;
        display: inline-block;
        vertical-align: top;
        opacity: 0.5;

        a {
          text-transform: none;
          text-decoration: none;
          color: inherit;
        }

        &:not(:first-child):not(:last-child) {
          margin: 0 15px;
        }

        &:first-child {
          margin-right: 15px;
        }

        &:last-child {
          margin-left: 15px;
        }

        &:hover {
          cursor: pointer;
        }

        .poster-wrap {
          width: inherit;
          border-radius: 45px;

          .channel-poster {
            height: 100%;
            width: auto;
            max-width: 100%;
            object-fit: cover;
            border-radius: 8px;
          }
        }

        &.exclusive {

          //width: 90px;

          .poster-wrap {
            //border: 1px solid black;

            .channel-poster {
              //border-radius: 45px;
            }
          }
        }

        .channel-item-title {
          margin-top: 8px;
          font-size: 14px;
          line-height: 16px;
          opacity: 0.5;
          text-transform: uppercase;
          max-height: calc(34px + 1rem);
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          white-space: break-spaces;
          text-align: center;
        }

        .channel-item-epg {
          font-size: 15px;
          line-height: 18px;
          opacity: 0.5;
        }

        &.active {
          opacity: 1;

          .channel-item-title {
            font-weight: 600;
            opacity: 1;
          }

          .channel-item-epg {
            opacity: 1;
          }
        }

      }
    }

    .main-player {
      border-radius: 10px;
      margin: auto;
    }

    .channels-title {
      display: none;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
    }

    @include media-breakpoint-down(lg) {

      .ais-logo {
        width: 120px;
      }
      .channels-list {
        .channel-item {
          width: 90px;
          //opacity: 1;

          .channel-item-title {
            //opacity: 1;
          }
        }
      }
      .channels-title {
        display: block;
      }
    }
    @include media-breakpoint-down(md) {

      .channels-list {
        .channel-item {
          width: 90px;


        }
      }

    }
    @include media-breakpoint-down(sm) {

      .channels-list {
        .channel-item {
          width: 90px;


        }
      }

    }
  }

</style>
